import React, { useEffect, useState } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import video0 from './media/0.mp4';
import video1 from './media/1.mp4';
import video2 from './media/2.mp4';
import video3 from './media/3.mp4';
import common from '../../index.module.scss';
import s from './index.module.scss';

function Trainer(props) {
	const { T } = useT();
	function actionOnClick() {
		props.setShowVideo(true);

		document.querySelectorAll('[data-trainer-video]').forEach(el => {
			el.querySelector('video').pause();
			el.classList.remove(s.show);
		});
		document.querySelector(`[data-trainer-video="${props.number}"] video`).play();
		document.querySelector(`[data-trainer-video="${props.number}"]`).classList.add(s.show);
	}

	return (
		<section className={`${s.item} ${props.class}`} style={{ backgroundImage: props.cover }}>
			<h2 className={s.itemTitle}>{props.name}</h2>
			<div className={s.itemDescription}>{props.description}</div>
			<button className={s.itemButton} type="button" onClick={actionOnClick}>
				{T('trainers_button')}
			</button>
			<div className={s.trainer} />
		</section>
	);
}

function Videos(props) {
	const videos = {
		video0: {
			src: video0,
			title: window.locales.exercise_0,
		},
		video1: {
			src: video1,
			title: window.locales.exercise_1,
		},
		video2: {
			src: video2,
			title: window.locales.exercise_2,
		},
		video3: {
			src: video3,
			title: window.locales.exercise_3,
		},
	};

	function onWaiting(e) {
		e.target.parentNode.classList.add(s.showLoader);
	}

	function onPlaying(e) {
		e.target.parentNode.classList.remove(s.showLoader);
	}

	return (
		<div className={`${s.videoWrapper} ${props.showVideo && s.showVideoWrapper}`}>
			<div
				className={s.closeArea}
				onClick={() => {
					props.setShowVideo(false);
				}}
			/>
			<div className={s.subVideoWrapper} data-trainer-video="0">
				<button
					className={s.closeVideo}
					onClick={() => {
						props.setShowVideo(false);
					}}
					type="button"
					aria-label="Close video"
					title="Close video"
				/>
				<div className={s.loader} />
				<video
					id="workoutsPreferenciesVideo"
					className={`${s.video} ${s.video_0}`}
					muted
					loop
					playsInline
					preload="auto"
					onWaiting={e => {
						onWaiting(e);
					}}
					onPlaying={e => {
						onPlaying(e);
					}}
				>
					<source src={`${videos.video0.src}#t=0.0001`} type="video/mp4" />
				</video>
			</div>
			<div className={s.subVideoWrapper} data-trainer-video="1">
				<button
					className={s.closeVideo}
					onClick={() => {
						props.setShowVideo(false);
					}}
					type="button"
					aria-label="Close video"
					title="Close video"
				/>
				<div className={s.loader} />
				<video
					className={`${s.video} video_1 ${s.video_1}`}
					muted
					loop
					playsInline
					preload="auto"
					onWaiting={e => {
						onWaiting(e);
					}}
					onPlaying={e => {
						onPlaying(e);
					}}
				>
					<source src={`${videos.video1.src}#t=0.0001`} type="video/mp4" />
				</video>
			</div>
			<div className={s.subVideoWrapper} data-trainer-video="2">
				<button
					className={s.closeVideo}
					onClick={() => {
						props.setShowVideo(false);
					}}
					type="button"
					aria-label="Close video"
					title="Close video"
				/>
				<div className={s.loader} />
				<video
					className={`${s.video} video_2 ${s.video_2}`}
					muted
					loop
					playsInline
					preload="auto"
					onWaiting={e => {
						onWaiting(e);
					}}
					onPlaying={e => {
						onPlaying(e);
					}}
				>
					<source src={`${videos.video2.src}#t=0.0001`} type="video/mp4" />
				</video>
			</div>
			<div className={s.subVideoWrapper} data-trainer-video="3">
				<button
					className={s.closeVideo}
					onClick={() => {
						props.setShowVideo(false);
					}}
					type="button"
					aria-label="Close video"
					title="Close video"
				/>
				<div className={s.loader} />
				<video
					className={`${s.video} video_3 ${s.video_3}`}
					muted
					loop
					playsInline
					preload="auto"
					onWaiting={e => {
						onWaiting(e);
					}}
					onPlaying={e => {
						onPlaying(e);
					}}
				>
					<source src={`${videos.video3.src}#t=0.0001`} type="video/mp4" />
				</video>
			</div>
		</div>
	);
}

function Trainers(props) {
	const { T } = useT();
	const [showVideo, setShowVideo] = useState(false);

	const trainers = [
		{
			name: 'Asta',
			description: window.locales.trainer_1_description,
			class: s.asta,
		},
		{
			name: 'Andy',
			description: window.locales.trainer_2_description,
			class: s.andy,
		},
		{
			name: 'Artem',
			description: window.locales.trainer_3_description,
			class: s.artem,
		},
		{
			name: 'Mike Peele',
			description: window.locales.trainer_4_description,
			class: s.mike,
		},
	];

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'trainers',
			stepStatus: true,
		});
	}, []);

	return (
		<div className={`${common.step} ${s.trainers} ${props.isThisCurrentStep && s.animate}`}>
			<h1 className={common.stepTitle}>{T('trainers_title')}</h1>
			<div className={common.stepDescription}>{T('trainers_description')}</div>
			<ul className={s.items}>
				{trainers.map((item, index) => (
					<li className={s.itemWrapper} key={item.name}>
						<Trainer
							class={item.class}
							name={item.name}
							description={item.description}
							number={index}
							setShowVideo={setShowVideo}
						/>
					</li>
				))}
			</ul>
			<Videos showVideo={showVideo} setShowVideo={setShowVideo} />
		</div>
	);
}

export default Trainers;
